import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="px-6 py-10 max-w-3xl mx-auto" data-id="element-67">
      <FadeIn data-id="element-68">
        <div className="bg-white border-2 border-[#4A5D3A] rounded-3xl p-6 md:p-10 shadow-xl relative overflow-hidden" data-id="element-69">
          {/* Decorative background shield */}
          <ShieldCheck className="absolute -top-10 -right-10 text-[#4A5D3A]/5 w-64 h-64 pointer-events-none" data-id="element-70" />

          <div className="flex flex-col items-center text-center relative z-10" data-id="element-71">
            <div className="bg-[#4A5D3A] text-white p-4 rounded-full mb-4 shadow-lg" data-id="element-72">
              <ShieldCheck size={40} strokeWidth={1.5} data-id="element-73" />
            </div>

            <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#4A5D3A] mb-6" data-id="element-74">
              GARANTÍA DE PAZ MENTAL — 7 DÍAS COMPLETOS
            </h2>

            <div className="space-y-4 text-lg text-[#2D2A26]/90 leading-relaxed text-left" data-id="element-75">
              <p data-id="element-76">Prueba el protocolo durante 7 días.</p>

              <p data-id="element-77">
                Aplica los elixires. Usa la Hoja de Vaciado Mental. Sigue el
                paso a paso.
              </p>

              <p data-id="element-78">
                Si no sientes ninguna diferencia real en tu calma y tu descanso
                — escríbenos un email y te devolvemos cada centavo de tus $6.39
                USD.
              </p>

              <ul className="font-bold text-[#9B4F2B] space-y-2 py-4 text-center text-xl" data-id="element-79">
                <li data-id="element-80">Sin preguntas incómodas.</li>
                <li data-id="element-81">Sin formularios eternos.</li>
                <li data-id="element-82">Sin drama.</li>
              </ul>

              <div className="flex flex-col md:flex-row justify-center gap-4 text-center font-bold text-xl md:text-2xl pt-4 border-t border-gray-100" data-id="element-83">
                <span className="text-[#2D2A26]" data-id="element-84">
                  El riesgo es completamente nuestro.
                </span>
                <span className="text-[#4A5D3A]" data-id="element-85">
                  La calma es completamente tuya.
                </span>
              </div>
            </div>

            <div className="mt-8 bg-[#FAF6F0] p-5 rounded-xl italic text-[#2D2A26]/80 border border-[#4A5D3A]/10 w-full" data-id="element-86">
              ¿Por qué ofrecemos esto? Porque sabemos que funciona. Y porque
              $6.39 USD no debería ser nunca la razón por la que una mujer siga
              sin dormir.
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}